/**
 * A semantic versioning string representing the currently running version of
 * ToDesktop's backend.
 * @public
 */
export const getBackendVersion = () => window["todesktop"].desktopifyVersion;
/**
 * @public
 * @returns `true` if the current application is running in ToDesktop. `false`
 * if not running in ToDesktop (e.g. if running in a web browser).
 */
export const isDesktopApp = () => typeof window !== "undefined" && typeof window["todesktop"] === "object";
